import { createBrowserRouter, RouterProvider } from 'react-router';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

import routes from '@/routes';
import { Toaster } from '@/components/ui/sonner';
import { useNavigationEvents } from '@/hooks/useNavigationEvents';
import { OpenFeatureProvider } from '@openfeature/react-sdk';
import '@/lib/feature-flag';

const router = createBrowserRouter(routes);
const queryClient = new QueryClient();

export default function App() {
  useNavigationEvents(router);

  return (
    <OpenFeatureProvider>
      <QueryClientProvider client={queryClient}>
        <RouterProvider router={router} />
        <Toaster />
      </QueryClientProvider>
    </OpenFeatureProvider>
  );
}
